import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatButtonModule } from '@angular/material/button';
import { SignupPageComponent } from './components/page/signup-page.component';
import { SignupRoutingModule } from './signup-routing.module'; 
import { Angulartics2Module } from 'angulartics2';


@NgModule({
  declarations: [
	  SignupPageComponent,
  ],
  imports: [
    CommonModule,
    SignupRoutingModule,
    MatGridListModule,
    MatButtonModule,
    SharedModule,
    NgOptimizedImage,
    Angulartics2Module
  ],
})
export class SignupModule { }
